import React, { useEffect, useContext } from "react";

import { AppContext, ContextType } from "@/shared/context";
import { ErrorPageInformationParameter } from "@/components/errorPageInformationComponent/interface";
import { isNotUndefined } from "@/shared/FunctionCore";
import "@/components/errorPageInformationComponent/ErrorPageInformationStyles.scss";

const ErrorPageInformationComponent = (errorPageInformationParameter: ErrorPageInformationParameter) => {
	const {
		exceptionWithExceptionContextualDataSerializableCollection,
		requestIdentifier,
		subtitle,
		title
	} = errorPageInformationParameter;

	const { isSetCompanyErrorComponentMounted } = useContext(AppContext) as ContextType;

	useEffect(() => {
		isSetCompanyErrorComponentMounted(true)

		return () => { isSetCompanyErrorComponentMounted(false) }
	}, [])

	return <div className="errorPageInformation">
		<div className="dAndBLogoWrapper">
			<div className="dAndBLogo" />
		</div>

		<h2 className="title mt-3">
			{title || "Oh no! 500 Error"}
		</h2>

		<h3 className="subtitle mt-4 mb-5">
			{subtitle || "An error occurred while processing this request."}
		</h3>

		{
			isNotUndefined(requestIdentifier) && requestIdentifier.length > 0
				?
				<div className="errorId">
					Error ID:

					{" "}

					{requestIdentifier}
				</div>
				: <></>
		}

		{
			isNotUndefined(exceptionWithExceptionContextualDataSerializableCollection)
				?
				<div className="exceptionInformation">
					<div className="exceptionInformationHeader">
						Exception information (not shown in in production)
					</div>

					{
						(() => {
							const exceptionWithExceptionContextualDataSerializableCollectionLength = exceptionWithExceptionContextualDataSerializableCollection.length;

							return exceptionWithExceptionContextualDataSerializableCollection.map((ex, nu) => {
								const {
									exceptionContextualData,
									exceptionStackTraceAsString
								} = ex;

								const {
									componentContextCellNames,
									httpServletRequestRequestUri,
									resourcePath,
									resourceResourceType,
									resourceResourceTypeMadeAbsolute
								} = exceptionContextualData;

								return (
									<div
										className="exceptionWrapper"
										key={nu}>
										<div className="exceptionHeader">
											Exception
											{" "}

											{nu + 1}

											{" "}

											of

											{" "}

											{exceptionWithExceptionContextualDataSerializableCollectionLength}
										</div>

										<div>
											<span className="exceptionContextualDataHeading">
												Request URL
											</span>

											<pre className="exceptionContextualDataValue">
												{httpServletRequestRequestUri}
											</pre>
										</div>

										<div>
											<span className="exceptionContextualDataHeading">
												Resource path
											</span>

											<pre className="exceptionContextualDataValue">
												{resourcePath}
											</pre>
										</div>

										<div>
											<span className="exceptionContextualDataHeading">
												Resource type
											</span>

											<pre className="exceptionContextualDataValue">
												{resourceResourceType}
											</pre>
										</div>

										<div>
											<span className="exceptionContextualDataHeading">
												Resource type (absolute)
											</span>

											<pre className="exceptionContextualDataValue">
												{resourceResourceTypeMadeAbsolute}
											</pre>
										</div>

										<div>
											<span className="exceptionContextualDataHeading">
												Component context cell names
											</span>

											<pre className="exceptionContextualDataValue">
												{componentContextCellNames?.join(", ") ?? ""}
											</pre>
										</div>

										<div>
											<span className="exceptionContextualDataHeading">
												Exception stack trace
											</span>

											<pre className="exceptionContextualDataValue">
												{exceptionStackTraceAsString}
											</pre>
										</div>
									</div>
								);
							});
						})()
					}
				</div>
				: <></>
		}
	</div>;
};

export default ErrorPageInformationComponent